module.exports = __webpack_public_path__ + "static/media/brand-car-wreck-ipswich.0ed590c6.png";